import "./Spinner.css"

export default function Spinner({ hide, ...props }) {
    return props.show
        ? <div className="spinner-container" >
            { props.msg ?
                <div className="error">{ props.msg }</div>
                : <div className="spinner" /> }
        </div> : null
}